package com.sweetlime.dungeonamigo.cache

import kotlin.String

public data class Items(
  public val slug: String,
  public val name: String,
  public val type: String?,
  public val rarity: String?,
  public val requires_attunement: String?,
  public val description: String?,
  public val cost: String?,
  public val weight: String?,
)
